import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { ArrowRight, Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-6 py-32 text-center">
        <div className="h-display text-7xl md:text-8xl text-blue-700">404</div>
        <h1 className="h-display mt-4 text-3xl md:text-4xl text-slate-900">
          This page took an unplanned leave.
        </h1>
        <p className="mt-4 text-slate-600 leading-relaxed">
          The link may be broken or the page may have moved. Let's get you back on track.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="btn-hover inline-flex items-center gap-2 rounded-full bg-slate-900 text-white px-6 py-3 text-sm font-medium hover:bg-blue-700"
          >
            <HomeIcon size={16} /> Back to home
          </Link>
          <Link
            to="/services"
            className="btn-hover inline-flex items-center gap-2 rounded-full border border-slate-300 text-slate-900 px-6 py-3 text-sm font-medium hover:bg-slate-100"
          >
            Browse services <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
